<template>
  <b-modal
    no-close-on-backdrop
    size="md"
    hide-footer
    id="view_classification"
    title="EDITAR CLASSIFICAÇÃO"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-checkbox v-model="active" :value="1" :unchecked-value="0">
            Ativo
          </b-checkbox>
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            class="mr-2"
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir a classificação?"
            open-class="btn-delete"
            open-left-icon="fa-trash"
            open-text="EXCLUIR"
            @yes="evOnBtnDeleteClick"
          />
          <v-btn :disabled="loading" type="submit" class="btn-save ml-2">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../../Components/WarningRequiredFields";

import ErrorsMessages from "../../Components/ErrorsMessages";

import LabelRequiredField from "../../Components/LabelRequiredField";

import ConfirmationDialog from "../../Components/ConfirmationDialog";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "ViewClassification",

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
    ConfirmationDialog,
  },

  props: {
    classification: [Object, null],
  },

  data() {
    return {
      errors: [],
      loading: false,
      name: "",
      active: 0,
    };
  },

  watch: {
    classification() {
      if (this.classification) this.$bvModal.show("view_classification");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = this.classification.name;
      this.active = this.classification.active;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          id: this.classification.id,
          name: this.name,
          active: this.active,
        };
        const response = await api.patch(
          "/rest-home/providers/classification",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_classification");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnBtnDeleteClick() {
      try {
        this.loading = true;

        const params = { id: this.classification.id };
        const response = await api.delete(
          "/rest-home/providers/classification",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_classification");
          this.$emit("updated");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>